/* @ngInject */
const phoneRequest = (
  $q,
  phoneResource,
  errorHandler,
  valueHandler,
  labels
) => {
  const self = {}

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$phone.delete'
      phoneResource.delete({ action: _id, }, (res) => {
        if (res && res.success) {
          resolve(labels.phone.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.phone.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default phoneRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/services/request.service.js